import { Icon } from '@winnin/winnin_ui.components.icon'

import type { IInputActionViewProps } from './input-action.types'
import './input-action.styles..scss'

export function InputActionView({
  containerClass,
  name,
  onChange,
  placeholder,
  searchTerms,
  value,
  disabled,
  showDatalist,
  icon,
  onKeyPress,
}: IInputActionViewProps) {
  return (
    <div className={containerClass} data-testid="input-action">
      <div className="input-wrapper">
        <div className="icon-wrapper">
          {icon && <Icon fill="var(--gray_dark2)" width={24} height={24} className="InputAction-icon" icon={icon} />}
        </div>
        <input
          data-hj-allow
          data-testid="input-action-input"
          type="text"
          list="search-input"
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyPress}
          value={value}
          name={name}
          disabled={disabled}
        />
        {showDatalist && (
          <datalist id="search-input" data-testid="input-action-datalist">
            {searchTerms?.length > 0 && searchTerms?.map(item => <option value={item} key={item} />)}
          </datalist>
        )}
      </div>
    </div>
  )
}
